import React from 'react';
import InitialMotion from "../../marketingRendering/InitialMotion";
import { useServerHtml } from '../../marketingRendering/InitialHtmlContext';

function CTASection({ title, body, actions = [], showGlobe = true }) {
  const serverHtml = useServerHtml();
  return (
    <section className="cta-final">
      <InitialMotion as="div" motionKey={`cta-${title}`} className="container cta-inner" data-aos="fade-up">
        <h2>{title}</h2>
        <p>{body}</p>
        <div className="cta-ctas">
          {actions.map((action) => {
            const ButtonTag = action.variant === 'filled' ? 'md-filled-button' : 'md-outlined-button';
            return (
              <span className="btn-lg" key={action.label}>
                <ButtonTag
                  href={action.onClick ? undefined : action.href}
                  onClick={serverHtml ? undefined : action.onClick || undefined}
                >
                  {action.label}
                </ButtonTag>
              </span>
            );
          })}
        </div>
      </InitialMotion>
      {showGlobe && <div className="cta-globe" aria-hidden="true"></div>}
    </section>
  );
}

export default CTASection;
